import variables from '@/styles/element-variables.scss'
import axios from "axios"

const setting = {
  state: {
    theme: {
      pageBtn: variables.pageBtn,
      pageTab: variables.pageTab,
      menuBg: variables.menuBg,
      menuSubBg: variables.menuSubBg,
      menuBgHover: variables.menuBgHover,
      menuSubBgHover: variables.menuSubBgHover,
      menuFont: variables.menuFont,
      menuLogo: variables.menuLogo,
    },
    showSettings: true,
    tagsView: true,
    fixedHeader: true,
    sidebarLogo: false,
    skewTab: false, //设置多标签页样式为倾斜
    dataMasking: true, // 数据脱敏
    redirectUri: "https://open-oauth.jd.com/oauth2/to_login?app_key=84BCB1F73260F8CD53CB51105AE17F04&response_type=code&scope=snsapi_base&redirect_uri=https://auth.qunxian.net/JdAuth/Order",
  },
  getters: {

  },
  mutations: {
    CHANGE_SETTING: (state, { key, value }) => {
      if (state.hasOwnProperty(key)) {
        state[key] = value
      }
    },
    SET_DATAMASKING: (state, dataMasking) => {
      state.dataMasking = dataMasking;
    }
  },
  actions: {
    changeSetting({ commit }, data) {
      commit('CHANGE_SETTING', data)
    },
    dataMasking({ commit }) {
      axios.request({ baseURL: "/", url: '/config.json', method: 'get', }).then(res => {
        commit('SET_DATAMASKING', res.data.dataMasking)
      }).catch(err => {
        console.log("dataMasking_err", err)
      })
    }
  }
}

export default setting
